import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MainMobile} from './main/MainMobile';

export interface IDashboardMobileViewProps {
    dashboard: any;
}

@observer
export class DashboardMobileView extends TechseeBaseComponent<IDashboardMobileViewProps> {
    renderInternal(): JSX.Element {
        const {dashboard} = this.props;
        const dashboardState = dashboard?.dashboardState;

        if (!dashboardState?.dashboardControllerLoaded || dashboard.miniDashboard) {
            return <React.Fragment />;
        }

        return (
            <div className='ts-mobile-dashboard-view-area'>
                {/* Main Content - replaces ui-view="mobile-dashboard-view" */}
                <MainMobile main={dashboard} />
            </div>
        );
    }
}
